import { render, staticRenderFns } from "./TargetingFrequency.vue?vue&type=template&id=748bf366&"
import script from "./TargetingFrequency.vue?vue&type=script&lang=js&"
export * from "./TargetingFrequency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports